<div class="container" id="inventories">
  <div class="row">
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="inventories-header-title" class="section-title">{{ 'INVENTORIES.TITLE' | translate }}</h1>
          <p data-testid="inventories-header-subtitle" class="section-subtitle mt-1 text-base">{{ 'INVENTORIES.SUBTITLE' | translate }}</p>
        </div>
        <div class="flex items-end justify-between gap-3 actions-wr">

          <!-- Sort panel toggle -->
          <app-sort-panel
            data-testid="sort-panel"
            [columns]="sortableColumns"
            [currentSort]="sortPanelSort"
            (sortChange)="onSortPanelChange($event)">
          </app-sort-panel>

          <!-- Filters toggle -->
          <button type="button" data-testid="btn-toggle-filters" class="btn outline-btn" (click)="toggleActiveFiltersPanel()">
            {{ getActiveFiltersPanelOpen() ? ('FILTERS_PANEL.HIDE_FILTERS' | translate) : ('FILTERS_PANEL.DISPLAY_FILTERS' | translate) }}
          </button>

          @if (exports) {
            <button data-testid="btn-export" [disabled]="!(page?.results?.length)" class="btn outline-btn" (click)="onOpenExportModalbox()">{{ 'INVENTORIES.BTN_EXPORT' | translate }}</button>
          }
          @if (allowCreateInventory) {
            <button data-testid="btn-new-inventory" id="btn-create-inventory" class="btn primary-btn" (click)="goToCreateInventoryItemForm()">{{ 'INVENTORIES.BTN_NEW' | translate }}</button>
          }
        </div>
      </div>

      <!-- Filters panel (one per tab) -->
      @if (!isPendingTab) {
        <app-filters-panel
          #inventoriesFiltersPanel
          [columns]="inventoriesColumns"
          [storageKeyStrategy]="'tableName'"
          [tableName]="inventoriesPanelTableName"
          [fieldOverrides]="filtersPanelFieldOverrides"
          (dropdownLazyLoad)="onFiltersPanelDropdownLazyLoad($event)"
          (panelChange)="onFiltersPanelChange($event, 'list')">
        </app-filters-panel>
      } @else {
        <app-filters-panel
          #pendingFiltersPanel
          [columns]="pendingColumns"
          [storageKeyStrategy]="'tableName'"
          [tableName]="pendingPanelTableName"
          (panelChange)="onFiltersPanelChange($event, 'pending')">
        </app-filters-panel>
      }

      <hr role="presentation" class="w-full mb-3 border-t" [class.mt-6]="!isFiltersPanelOpen" [class.mt-1]="isFiltersPanelOpen">

      <div class="view-content-wr">
        <!-- main content -->
        <p-tabs [value]="activeTabIndex" (valueChange)="onTabChange($event)">

          <p-tablist>
            <p-tab [value]="0">
              {{ 'INVENTORIES.TABS.INVENTORIES_LIST' | translate }}
            </p-tab>

            @if (manualInventory) {
              <p-tab [value]="1">
                {{ 'INVENTORIES.TABS.PENDING_INVENTORIES' | translate }}
              </p-tab>
            }
          </p-tablist>

          <p-tabpanels>
            <!-- Inventories list -->
            <p-tabpanel [value]="0">
              <div class="row">
                <div class="flex flex-col col-12 mb-2 text-wr">
                  <p-table data-testid="table" [columns]="inventoriesColumns" [value]="data" [lazy]="true" [customSort]="true"
                    [sortField]="primeTableSortField" [sortOrder]="primeTableSortOrder"
                    (onLazyLoad)="customSort($event, 'list')">

                    <ng-template #header let-columns>
                      <tr>
                        @for (col of columns; track col; let colIndex = $index) {
                          <!-- Normal sortable columns -->
                          @if (colIndex !== columns.length - 1 && col.sortable !== false) {
                            <th [pSortableColumn]="col.field">
                              <div class="header-wr">
                                <span [attr.data-testid]="'table-header-' + colIndex" class="col-name">
                                  {{ ('TABLE.HEADER.' + col.header) | translate }}
                                </span>
                                <span class="sort-icon" aria-hidden="true">
                                  @if (isColumnUnsorted(col.field)) {
                                    <i class="pi pi-sort-alt"></i>
                                  }
                                  @if (isColumnSortedAsc(col.field)) {
                                    <i class="pi pi-sort-amount-up-alt"></i>
                                  }
                                  @if (isColumnSortedDesc(col.field)) {
                                    <i class="pi pi-sort-amount-down-alt"></i>
                                  }
                                </span>
                              </div>
                            </th>
                          }

                          <!-- Non-sortable columns -->
                          @if (colIndex !== columns.length - 1 && col.sortable === false) {
                            <th>
                              <div class="header-wr">
                                <span [attr.data-testid]="'table-header-' + colIndex" class="col-name">
                                  {{ ('TABLE.HEADER.' + col.header) | translate }}
                                </span>
                              </div>
                            </th>
                          }

                          <!-- Actions column -->
                          @if (colIndex === columns.length - 1) {
                            <th>
                              <span data-testid="table-header-actions" class="col-name">
                                {{ ('TABLE.HEADER.' + col.field) | translate }}
                              </span>
                            </th>
                          }
                        }
                      </tr>
                    </ng-template>

                    <ng-template #body let-rowData let-columns="columns" let-i="rowIndex">
                      <tr>
                        @for (col of columns; track col; let colIndex = $index) {
                          <td [ngClass]="{'actions-col': colIndex === columns.length - 1}">
                            @if (colIndex !== columns.length - 1) {
                              <span class="p-column-title">
                                {{ ('TABLE.HEADER.' + col.header) | translate }}:
                              </span>
                              <span [attr.data-testid]="'cell-' + colIndex + '-' + i">
                                {{ tableSettingService.getColumnValue(rowData, col) | defaultValue }}
                              </span>
                            } @else {
                              <div class="flex justify-center">
                                <button type="button" [pTooltip]="'ITEMS.TOOLTIP_VIEW_DETAILS' | translate" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-eye" (click)="goToInventoryDetails($event, rowData.id)" [attr.data-testid]="'btn-view-' + i">
                                  <span class="btn-label">
                                    {{ 'INVENTORIES.VIEW_INVENTORY_DETAILS' | translate }}
                                  </span>
                                </button>
                              </div>
                            }
                          </td>
                        }
                      </tr>
                    </ng-template>
                    <ng-template #emptymessage>
                      <tr>
                        <td [attr.colspan]="inventoriesColumns.length || 0">
                          {{ 'ITEMS.NO_DATA' | translate }}
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>

                  <!-- Inventories pagination -->
                  @if (!isPendingTab) {
                    <app-custom-paginator
                      data-testid="paginator"
                      [pageNumber]="pageNumber"
                      [rows]="pageSize"
                      [totalRecords]="page?.totalCount ?? 0"
                      [rowsPerPageOptions]="[10, 20, 30]"
                      [showCurrentPageReport]="true"
                      [currentPageReportTemplate]="'PAGINATOR.CURRENT_PAGE_REPORT' | translate"
                      [disabled]="!page"
                      [alwaysShow]="true"
                      [tableName]="inventoriesPanelTableName"
                      [showFirstLastIcon]="true"
                      [showPageLinks]="true"
                      [showPageSizeSelector]="true"
                      (onPageChange)="onPageChange($event, 'list')">
                    </app-custom-paginator>
                  }
                </div>
              </div>
            </p-tabpanel>

            <!-- Pending inventories -->
            @if (manualInventory) {
              <p-tabpanel [value]="1">
                @if (!sendEmail) {
                  <div class="flex flex-col col-12 mb-2 text-wr">
                    <p-table data-testid="pending-table" [columns]="pendingColumns" [value]="data" [lazy]="true" [customSort]="true" [sortField]="primeTableSortField" [sortOrder]="primeTableSortOrder" (onLazyLoad)="customSort($event, 'pending')">

                      <ng-template #header let-columns>
                        <tr>
                          @for (col of columns; track col; let colIndex = $index) {
                            <!-- Normal sortable columns -->
                            @if (colIndex !== columns.length - 1 && col.sortable !== false) {
                              <th [pSortableColumn]="col.field">
                                <div class="header-wr">
                                  <span [attr.data-testid]="'table-header-' + colIndex" class="col-name">
                                    {{ ('TABLE.HEADER.' + col.header) | translate }}
                                  </span>
                                  <span class="sort-icon" aria-hidden="true">
                                    @if (isColumnUnsorted(col.field)) {
                                      <i class="pi pi-sort-alt"></i>
                                    }
                                    @if (isColumnSortedAsc(col.field)) {
                                      <i class="pi pi-sort-amount-up-alt"></i>
                                    }
                                    @if (isColumnSortedDesc(col.field)) {
                                      <i class="pi pi-sort-amount-down-alt"></i>
                                    }
                                  </span>
                                </div>
                              </th>
                            }

                            <!-- Non-sortable columns -->
                            @if (colIndex !== columns.length - 1 && col.sortable === false) {
                              <th>
                                <div class="header-wr">
                                  <span [attr.data-testid]="'table-header-' + colIndex" class="col-name">
                                    {{ ('TABLE.HEADER.' + col.header) | translate }}
                                  </span>
                                </div>
                              </th>
                            }

                            <!-- Actions column -->
                            @if (colIndex === columns.length - 1) {
                              <th>
                                <span data-testid="table-header-actions" class="col-name">
                                  {{ ('TABLE.HEADER.' + col.field) | translate }}
                                </span>
                              </th>
                            }
                          }
                        </tr>
                      </ng-template>

                      <ng-template #body let-rowData let-columns="columns" let-i="rowIndex">
                        <tr>
                          @for (col of columns; track col; let colIndex = $index) {
                            <td [ngClass]="{'actions-col': colIndex === columns.length - 1}">
                              @if (colIndex !== columns.length - 1) {
                                <span class="p-column-title">
                                  {{ ('TABLE.HEADER.' + col.header) | translate }}:
                                </span>
                                <span [attr.data-testid]="'cell-' + colIndex + '-' + i">
                                  {{ tableSettingService.getColumnValue(rowData, col) | defaultValue }}
                                </span>
                              } @else {
                                <div class="flex justify-center">
                                  <button type="button" [pTooltip]="'CUSTOMER_SINGLE_VIEW.TOOLTIP_EMAIL' | translate" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-email" (click)="onOpenEmailModal($event, rowData)" [attr.data-testid]="'btn-email-' + i">
                                    <span class="btn-label">
                                      {{ 'DIGITAL_CARDS.BTN_SEND_EMAIL' | translate }}
                                    </span>
                                  </button>
                                </div>
                              }
                            </td>
                          }
                        </tr>
                      </ng-template>

                      <ng-template #emptymessage>
                        <tr>
                          <td [attr.colspan]="pendingColumns.length || 0">
                            {{ 'ITEMS.NO_DATA' | translate }}
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>

                    <!-- Pending inventories pagination -->
                    @if (!isPendingTab) {
                      <app-custom-paginator
                        data-testid="pending-paginator"
                        [pageNumber]="pageNumber"
                        [rows]="pageSize"
                        [totalRecords]="page?.totalCount ?? 0" [rowsPerPageOptions]="[5, 10, 20, 30]"
                        [showCurrentPageReport]="true"
                        [currentPageReportTemplate]="'PAGINATOR.CURRENT_PAGE_REPORT' | translate"
                        [disabled]="!page"
                        [alwaysShow]="true"
                        [tableName]="pendingPanelTableName"
                        [showFirstLastIcon]="true"
                        [showPageLinks]="true"
                        [showPageSizeSelector]="true"
                        (onPageChange)="onPageChange($event, 'pending')">
                      </app-custom-paginator>
                    }
                  </div>
                }
              </p-tabpanel>
            }
          </p-tabpanels>
        </p-tabs>
      </div>
    </div>
  </div>
</div>

<app-dialog-export [(visible)]="displayExportModalbox" [currentDate]="currentDate"
  (exportSubmit)="handleExportSubmit($event)"></app-dialog-export>

<p-dialog [header]="'DIGITAL_CARDS.BTN_SEND_EMAIL' | translate" [(visible)]="displayEmailModalbox" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false" [closable]="true" [appendTo]="'body'" [baseZIndex]="1200" class="compact-modal">
  <form [formGroup]="emailForm" (ngSubmit)="onSubmitEmailForm()" class="mt-0">
    <input type="hidden" id="id" formControlName="id">
    <div class="field-wr flex flex-col col-12">
      <label class="block text-sm" for="email">
        {{ 'MODALBOXES.EMAIL_RECIPIENT' | translate }}<i class="icon-required-field"></i>
      </label>
      <input type="text" id="email" formControlName="email" autocomplete="off">
      @if (
        emailForm.get('email')?.invalid &&
        (emailForm.get('email')?.dirty || emailForm.get('email')?.touched)
      ) {
        @if (emailForm.get('email')?.hasError('required')) {
          <small class="p-error">
            {{ 'MODALBOXES.EMAIL_REQUIRED' | translate }}
          </small>
        }
        @if (emailForm.get('email')?.errors?.['invalidEmail']) {
          <small class="p-error">
            {{ 'YOUR_ACCOUNT.VALIDATE_EMAIL_SYNTAX' | translate }}
          </small>
        }
      }
    </div>
  </form>
  <ng-template #footer>
    <button id="btn-cancel-email-card" type="button" class="btn outline-btn" (click)="onCancelEmailModal()">
      {{ 'MODALBOXES.BTN_CANCEL' | translate }}
    </button>
    <button id="btn-send-email-card" type="submit" class="btn primary-btn" [disabled]="emailForm.invalid"
      (click)="onSubmitEmailForm()">
      {{ 'MODALBOXES.BTN_SEND_EMAIL' | translate }}
    </button>
  </ng-template>
</p-dialog>
